module.exports = __webpack_public_path__ + "static/media/google.f90f33a3.svg";